import { useState } from 'react';

type ProfileCardModals = undefined | 'addCard' | 'success';

type useAddCardModalParams = {
  onClose?: () => void;
};

export const useAddCardModal = ({ onClose }: useAddCardModalParams = {}) => {
  const [openCardsModal, setOpenCardsModal] = useState<ProfileCardModals>();

  const addCardProps = {
    opened: openCardsModal == 'addCard',
    onClose: () => {
      setOpenCardsModal(undefined);
      onClose?.();
    },
    onComplete: () => {
      setOpenCardsModal('success');
      onClose?.();
    },
  };
  const successProps = {
    opened: openCardsModal == 'success',
    onClose: () => {
      setOpenCardsModal(undefined);
      onClose?.();
    },
    onComplete: () => {
      setOpenCardsModal(undefined);
      onClose?.();
    },
  };

  const openAddCardModal = () => setOpenCardsModal('addCard');

  return { openAddCardModal, openCardsModal, setOpenCardsModal, addCardProps, successProps };
};
